import callouts from './callouts';
import chartsFidelity from './chartsFidelity';
import chartsSatisfaction from './chartsSatisfaction';

export default [callouts, chartsFidelity, chartsSatisfaction];
